import { render, staticRenderFns } from "./sys-pagination.vue?vue&type=template&id=8f2db68c&scoped=true"
import script from "./sys-pagination.vue?vue&type=script&lang=js"
export * from "./sys-pagination.vue?vue&type=script&lang=js"
import style0 from "./sys-pagination.vue?vue&type=style&index=0&id=8f2db68c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2db68c",
  null
  
)

export default component.exports